(function(){
  function tween(get,set,to,ms){
    var from=get(); if(Math.abs(to-from)<1){return;}
    var t0=Date.now();
    var iv=setInterval(function(){
      var p=Math.min(1,(Date.now()-t0)/ms);
      var e=p<0.5?4*p*p*p:1-Math.pow(-2*p+2,3)/2;
      set(from+(to-from)*e);
      if(p>=1){clearInterval(iv);set(to);}
    },16);
  }
  document.addEventListener('click',function(ev){
    if(!ev.target||!ev.target.closest){return;}
    var arrow=ev.target.closest('[data-vt-scroll]');
    if(arrow){
      var track=document.getElementById(arrow.getAttribute('data-vt-target'));
      if(track){
        var dir=parseInt(arrow.getAttribute('data-vt-scroll'),10)||1;
        var max=track.scrollWidth-track.clientWidth;
        var to=Math.max(0,Math.min(max,track.scrollLeft+dir*track.clientWidth*0.6));
        tween(function(){return track.scrollLeft;},function(v){track.scrollLeft=v;},to,420);
      }
      return;
    }
    var vid=ev.target.closest('[data-vt-video]');
    if(vid){
      var el=vid.querySelector('video');
      if(!el||el.error){return;}
      var playing=vid.getAttribute('aria-pressed')==='true';
      document.querySelectorAll('[data-vt-video] video').forEach(function(v){if(v!==el){v.pause();}});
      document.querySelectorAll('[data-vt-video]').forEach(function(b){if(b!==vid){b.setAttribute('aria-pressed','false');}});
      if(playing){el.pause();vid.setAttribute('aria-pressed','false');return;}
      var pr=el.play();
      if(pr&&pr.then){pr.then(function(){vid.setAttribute('aria-pressed','true');}).catch(function(){vid.setAttribute('aria-pressed','false');});}
      else{vid.setAttribute('aria-pressed','true');}
      return;
    }
    var thumb=ev.target.closest('[data-vt-thumb]');
    if(thumb){
      var main=document.getElementById('vt-gallery-main');
      if(main){main.src=thumb.getAttribute('data-vt-thumb');}
      thumb.parentNode.querySelectorAll('[data-vt-thumb]').forEach(function(b){b.setAttribute('aria-current',b===thumb?'true':'false');});
      return;
    }
    var jump=ev.target.closest('[data-vt-jump]');
    if(jump){
      var target=document.querySelector(jump.getAttribute('data-vt-jump'));
      if(target){
        ev.preventDefault();
        var max2=document.documentElement.scrollHeight-window.innerHeight;
        var y=Math.max(0,Math.min(max2,target.getBoundingClientRect().top+window.scrollY-90));
        tween(function(){return window.scrollY;},function(v){window.scrollTo(0,v);},y,520);
      }
    }
  });
  document.addEventListener('change',function(ev){
    if(!ev.target||!ev.target.closest){return;}
    var radio=ev.target.closest('.vt-variant input');
    if(!radio){return;}
    var group=radio.closest('.vt-variants');
    if(group){group.querySelectorAll('.vt-variant').forEach(function(l){l.setAttribute('aria-checked',l.contains(radio)?'true':'false');});}
    if(radio.hasAttribute('data-vt-pkg')){
      var now=document.querySelector('.vt-price__now');
      var total=radio.getAttribute('data-total');
      if(now&&total){now.textContent=total;}
      var sp=document.querySelector('[data-vt-sticky-price]');
      if(sp&&total){sp.textContent=total;}
    }
  });
  // sticky bar visibility
  function initSticky(){
    var bar=document.querySelector('[data-vt-sticky]');
    if(!bar){return;}
    var anchor=document.getElementById('vt-buy')||document.querySelector('.vt-btn--block');
    if(!anchor){return;}
    function update(){
      var r=anchor.getBoundingClientRect();
      var past=r.bottom<0;
      var atFooter=(window.innerHeight+window.scrollY)>=(document.documentElement.scrollHeight-140);
      if(past&&!atFooter){bar.classList.add('is-visible');}else{bar.classList.remove('is-visible');}
    }
    update();
    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update);
  }
  if(document.readyState!=='loading'){initSticky();}else{document.addEventListener('DOMContentLoaded',initSticky);}
})();
